import { PropsWithChildren } from "react"
import { Navigate } from "react-router-dom"
import Cookies from "js-cookie"

import { getAxiosBaseUrl } from "@/store/rtk-api/axiosBaseQuery"
import { useGetMeQuery } from "@/store/userAPI"

import routes from "./routes.ts"

const AuthRoute = ({ children }: PropsWithChildren) => {
  // First-party auth cookies are client-readable. A fresh visitor has no
  // session to probe or rotate. A direct API on another origin still needs the
  // server check because its cookies are not visible to this document.
  const sameOrigin = new URL(getAxiosBaseUrl(), window.location.origin).origin === window.location.origin
  const skip = sameOrigin && !Cookies.get("accessToken") && !Cookies.get("refreshToken")
  const { data, isLoading } = useGetMeQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip,
  })

  // Hide the public auth page only during the initial session check. After an
  // unauthenticated response, background refetches must not blank the login
  // form while token rotation is being attempted.
  if (!skip && isLoading) {
    return null
  }

  return !skip && data?.success ? <Navigate replace to={routes.dashboard} /> : children
}

export default AuthRoute
